<template>
  <div>
    <b-form-group
      label="Select The Condition"
      class="dropdownModuleFields w-100"
      label-for="awaitType"
      label-cols-md="12"
    >
      <select-field
        :select-model="data.conditions.value"
        :select-options="options"
        :field="{}"
      />
    </b-form-group>

    <b-form-group
      v-if="data.conditions.value === 86"
      :label="data.conditions.fields.label"
      class="dropdownModuleFields w-100"
      label-for="awaitType"
      label-cols-md="12"
    >
      <select-field
        v-if="data.conditions.fields.type === 'select'"
        :select-model="data.conditions.fields.value"
        :select-options="data.conditions.fields && data.conditions.fields.options.length > 0 ? data.conditions.fields.options : getOptions(data.conditions.value)"
        :field="data.conditions.fields"
      />
    </b-form-group>
    <template
      v-if="data.conditions.fields && data.conditions.fields.length > 0"
    >
      <fields
        :condition-fields="data.conditions.fields"
      />
    </template>
    <b-form-group
      label="Operator"
      class="dropdownModuleFields w-100"
      label-for="awaitType"
      label-cols-md="12"
    >
      <select-field
        :select-model="data.operator"
        :select-options="operatorOptions"
        :field="{}"
      />
    </b-form-group>
    <b-form-group
      label="If Condition is true"
      :label-for="`true-condition-${data}`"
    >
      <v-select
        v-model="data.ifTrue.value"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        :options="sharedState.templateVariableOptions"
        :reduce="val => val.value"
        :clearable="false"
      >
        <template
          slot="option"
          slot-scope="option"
        >
          <div :class="assignClass(option.value) ? 'autofik' : ''">
            {{ option.label }}
          </div>
        </template>
      </v-select>
    </b-form-group>
    <template
      v-if="data.ifTrue.data && data.ifTrue.data.fields.length > 0"
    >
      <fields
        :condition-fields="data.ifTrue.data.fields"
      />
    </template>
    <template
      v-if="!data.ifTrue.data && data.ifTrue.functional_value"
    >
      <InputType
        :select-model="data.ifTrue.functional_value"
      />
    </template>
    <b-form-group
      label="If Condition is false"
      :label-for="`false-condition-${data}`"
    >
      <v-select
        v-model="data.ifFalse.value"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        :options="sharedState.templateVariableOptions"
        :reduce="val => val.value"
        :clearable="false"
      >
        <template
          slot="option"
          slot-scope="option"
        >
          <div :class="assignClass(option.value) ? 'autofik' : ''">
            {{ option.label }}
          </div>
        </template>
      </v-select>
    </b-form-group>
    <template
      v-if="(data.ifFalse.data && !data.ifFalse.functional_value) && data.ifFalse.data.fields.length > 0"
    >
      <fields
        :condition-fields="data.ifFalse.data.fields"
      />
    </template>
    <template
      v-if="!data.ifFalse.data && data.ifFalse.functional_value"
    >
      <InputType
        :select-model="data.ifFalse.functional_value"
      />
    </template>
  </div>
</template>

<script>
import vSelect from 'vue-select'
// import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormGroup,
// BFormInput,
} from 'bootstrap-vue'
import Fields from './fields/Fields.vue'
import SelectField from './fields/SelectField.vue'
import InputType from './fields/InputType.vue'

export default {
  inject: ['sharedState'], // Inject the reactive shared state
  components: {
    // BFormInput,
    vSelect,
    BFormGroup,
    SelectField,
    Fields,
    InputType,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    assignClass: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      selectModel: '',
      options: [],
      operatorOptions: [
        { label: 'True', value: 1 },
        { label: 'False', value: 2 },
      ],
    }
  },
  watch: {
    'sharedState.conditions': {
      handler() {
        this.options = this.sharedState.conditions
      },
    },
  },
  created() {
  },
  methods: {
    getOptions(id) {
      let options = []
      if (id === 86) {
        options = this.sharedState.AirportsData
      }
      return options
    },
  },
}
</script>

 <style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
 </style>
